import React, { useCallback, useRef, useState } from "react";
import { FaTrashAlt } from "react-icons/fa";
// import ModalContainer from "../modals/ModalContainer";
// import Select from "../form/select/Select";
// import { useSelector } from "react-redux";
import SelectCover from "../modals/policy/SelectCover";
import SelectLifeCover from "../modals/policy/SelectLifeCover";
import { useFormik } from "formik";
import * as yup from "yup";
import MultiSelect from "../form/select/MultiSelect";

const multipleData = [
  { name: 'Total Contribution', id: 'total contribution'},
  { name: 'Savings Balance', id: 'savings balance'},
]

const Cover = ({ genInfoRef, interestRef, setCover, setLifeCover, setLifeCoverValues }) => {
  // const { cover } = useSelector((state) => state.policy);
  const [data, setData] = useState([]);
  const [lifeData, setLifeData] = useState([]);
  const [error, setError] = useState("");
  const [lifeError, setLifeError] = useState("");

  const multiRef = useRef(null);

  // const setErrorMemo = useCallback((dataCheck) => {
  //   if (dataCheck.every((item) => item.value === "")) {
  //     setError("Atleast one cover is required");
  //     return;
  //   } else {
  //     setError("");
  //   }
  // });
  const setLifeErrorMemo = useCallback((dataCheck) => {
    if (dataCheck.every((item) => item.value === "")) {
      setLifeError("Atleast one life cover is required");
      return;
    } else {
      setLifeError("");
    }
  });

  const handleCoverChange = (value) => {
     // Check if the selected value is already present in the data state
    const isValuePresent = data.some(item => item.value === value.value);

    // If the value is already present, return without adding it again
    if (isValuePresent) {
      return;
    }
    let newData;
    if (data.length === "") {
      newData = [value];
    } else {
      newData = [...data, value];
    }
    setData(newData);
    setCover(newData.map((item) => item.value));
    // setErrorMemo(newData);
  };

  const handleLifeChange = (value) => {
    if (lifeData.includes(value.value)) return;
    let newData;
    if (lifeData.length === "") {
      newData = [value];
    } else {
      newData = [...lifeData, value];
    }
    setLifeData(newData);
    setLifeCover(newData.map((item) => item.value));
    setLifeErrorMemo(newData);
  };

  const DeleteCover = (e, i) => {
    const deleteCover = [...data];
    deleteCover.splice(i, 1);
    setData(deleteCover);
    setCover(deleteCover);
    // setErrorMemo(deleteCover);
  };

  const DeleteLifeCover = (e, i) => {
    const deleteCover = [...lifeData];
    deleteCover.splice(i, 1);
    setLifeData(deleteCover);
    setLifeCover(deleteCover);
    setLifeErrorMemo(deleteCover);
  };

  const onSubmit = (values) => {
    let payload;
    if (values?.life_cover_claim_name === "assumed") {
      payload = { life_cover_claim_name: values.life_cover_claim_name };
    }
    if (values?.life_cover_claim_name === "multiple") {
      payload = { 
        life_cover_claim_name: values.life_cover_claim_name ,
        value: values?.value
      };
    }
    if (values?.life_cover_claim_name === "guaranteed") {
      if (values?.guaranteed_type === "fixed") {
        payload = { 
          life_cover_claim_name: values.life_cover_claim_name ,
          guaranteed_type: values.guaranteed_type ,
          value: values?.fixed_value
        };
      } else {
        payload = { 
          life_cover_claim_name: values.life_cover_claim_name ,
          guaranteed_type: values.guaranteed_type ,
          assumed_garranty_minimum: values.assumed_garranty_minimum,
          assumed_garranty_maximum: values.assumed_garranty_maximum,
        };
      }
    }
    setLifeErrorMemo(lifeData);
    if (  lifeData.every((item) => item === "")) return;
    setLifeCoverValues(payload);
    interestRef?.current?.click();
  };

  const {
    errors,
    values,
    touched,
    handleBlur,
    handleSubmit,
    handleChange,
    setFieldValue,
    getFieldProps,
    // setFieldError,
    // resetForm,
  } = useFormik({
    // enableReinitialize: true,
    initialValues: {
      life_cover_claim_name: "multiple",
      guaranteed_type: "fixed",
      fixed_value: "",
      assumed_garranty_minimum: "",
      assumed_garranty_maximum: "",
      value: [],
    },
    onSubmit,
    validate: (values) => {
        const errors = {};
        if (values?.life_cover_claim_name === 'multiple' && values.value.length < 1) {
            errors.value = "Atleast one value must be selected";
        }
        if (values?.life_cover_claim_name === "guaranteed" && values?.guaranteed_type === "fixed" && values?.fixed_value === "") {
            errors.fixed_value = "Fixed value is required";  
        }
        if (values?.life_cover_claim_name === "guaranteed" && values?.guaranteed_type === "range" && (values?.assumed_garranty_maximum === "" || values?.assumed_garranty_minimum === "")) {
            errors.assumed_garranty_maximum = "Both Min and Max are required";  
        }
        if (values?.life_cover_claim_name === "guaranteed" && values?.guaranteed_type === "range" && (parseFloat(values?.assumed_garranty_maximum) < parseFloat(values?.assumed_garranty_minimum))) {
            errors.assumed_garranty_maximum = "Minimum cannot be greater than Maximum";  
        }
        return errors;
    },
    validationSchema: () =>
        yup.object().shape({
            life_cover_claim_name: yup.string().required("Life Cover Name is required"),
        }),
    });    


  return (
    <form onSubmit={handleSubmit} className='row'>
      <div className='col-md-12 mb-3'>
        <label htmlFor='cover_payable' className='form-label'>
          Life Cover<span className='text-danger'>*</span>
        </label>
        {lifeData?.map((item, i) => (
          <div
            key={i}
            className='d-flex align-items-center justify-content-between shadow-sm p-2'
          >
            <span>{item?.label}</span>
            <span
              className='ms-3 cursor-p'
              onClick={(e) => DeleteLifeCover(e, i)}
            >
              <FaTrashAlt size={12} className='text-danger' />
            </span>
          </div>
        ))}
        {lifeError && <div className='text-danger'>{lifeError}</div>}
      </div>
      {lifeData.length >= 1 ? null : (
        <div className='col-md-12 mb-3'>
          <button
            type='button'
            className='btn btn-primary btn-sm'
            // onClick={(e) => {
            //   setData([...data, ""]);
            // }}
            data-bs-toggle='modal'
            data-bs-target='#lifecover-select'
          >
            <i className='mdi mdi-plus me-1'></i>
            <span>Add</span>
          </button>
        </div>
      )}
      <div className="mb-3">
        <div className='mb-0 col-md-12 mt-3'>
          <label className='form-label'>Life Cover Claims</label>
        </div>
        <div class='form-check my-1'>
            <input
            class='form-check-input mx-1'
            type='radio'
            name='life_cover_claim_name'
            id='life_cover_claim_name'
            value='multiple'
            onChange={handleChange}
            defaultChecked={values?.life_cover_claim_name === "multiple"}
            />
            <label class='form-check-label' for='company_wide'>
                Multiple
            </label>
            {values?.life_cover_claim_name === "multiple" && (
                <div className='ms-3'>
                    <MultiSelect
                    isError={
                        errors?.value
                    }
                    name='value'
                    field={{ ...getFieldProps("value") }}
                    data={multipleData?.map((item, i) => ({
                        label: item?.name,
                        value: item?.id,
                    }))}
                    onChange={setFieldValue}
                    onBlur={() => {
                        handleBlur({ target: { name: "value" } });
                    }}
                    defaultValue={values.value}
                    errors={errors}
                    touched={touched}
                    disabled={values?.life_cover_claim_name !== "multiple"}
                    ref={multiRef}
                    />
                </div>
            )}
        </div>
        <div class='form-check my-1'>
            <input
            class='form-check-input mx-1'
            type='radio'
            name='life_cover_claim_name'
            value='assumed'
            onChange={handleChange}
            id='life_cover_claim_name'
            />
            <label class='form-check-label' for='rab'>
                Assumed Sum Assured
            </label>
        </div>
        <div class='form-check my-1'>
            <input
            class='form-check-input mx-1'
            type='radio'
            name='life_cover_claim_name'
            value='guaranteed'
            onChange={handleChange}
            id='life_cover_claim_name'
            />
            <label class='form-check-label' for='rab'>
                Guaranteed Sum Assured
            </label>
        </div>
        {values?.life_cover_claim_name === "guaranteed" && <div className="ms-3">
          <div class='form-check my-1'>
            <input
            class='form-check-input mx-1'
            type='radio'
            name='guaranteed_type'
            value='fixed'
            onChange={handleChange}
            id='guaranteed_type'
            defaultChecked={values?.guaranteed_type === "fixed"}
            />
            <label class='form-check-label' for='rab'>
              Fixed Value
            </label>
          </div>
          {values?.guaranteed_type === 'fixed' && 
            <div className='ms-4'>
              <input
                type='number'
                className='form-control form-control-sm'
                id='fixed_value'
                name='fixed_value'
                value={values?.fixed_value}
                onChange={handleChange}
              />
              {errors?.fixed_value && touched?.fixed_value && (
                <span className='text-danger'>{errors?.fixed_value}</span>
              )}
            </div>
          }
          <div class='form-check my-1'>
            <input
            class='form-check-input mx-1'
            type='radio'
            name='guaranteed_type'
            value='range'
            onChange={handleChange}
            id='guaranteed_type'
            />
            <label class='form-check-label' for='rab'>
              Range
            </label>
          </div>
          {values?.guaranteed_type === 'range' && 
            <div className="row ms-4">
              <div className="col-md-6 d-flex flex-row gap-2">
                <label className="">Min</label>  
                <input
                  type='number'
                  className='form-control form-control-sm'
                  id='assumed_garranty_minimum'
                  name='assumed_garranty_minimum'
                  value={values?.assumed_garranty_minimum}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6 d-flex flex-row gap-2">
                <label className="">Max</label>  
                <input
                  type='number'
                  className='form-control form-control-sm'
                  id='assumed_garranty_maximum'
                  name='assumed_garranty_maximum'
                  value={values?.assumed_garranty_maximum}
                  onChange={handleChange}
                />
              </div>
              {errors?.assumed_garranty_maximum && touched?.assumed_garranty_maximum && (
                <span className='text-danger'>{errors?.assumed_garranty_maximum}</span>
              )}
            </div>
          }
        </div>}
      </div>
      <div className='col-md-12 mb-3'>
        <label htmlFor='cover_payable' className='form-label'>
          Other Cover
        </label>
        {data?.map((item, i) => (
          <div
            key={i}
            className='d-flex align-items-center justify-content-between shadow-sm p-2'
          >
            <span>{item?.label}</span>
            <span className='ms-3 cursor-p' onClick={(e) => DeleteCover(e, i)}>
              <FaTrashAlt size={12} className='text-danger' />
            </span>
          </div>
        ))}
        {error && <div className='text-danger'>{error}</div>}
      </div>
      <div className='col-md-12 mb-3'>
        <button
          className='btn btn-primary btn-sm'
          // onClick={(e) => {
          //   setData([...data, ""]);
          // }}
          type="button"
          data-bs-toggle='modal'
          data-bs-target='#cover-select'
        >
          <i className='mdi mdi-plus me-1'></i>
          <span>Add</span>
        </button>
      </div>
      <div className='mt-4 d-flex justify-content-end'>
        <button
          type="button"
          className='btn btn-info text-white me-3'
          onClick={() => genInfoRef?.current?.click()}
        >
          <i className='mdi mdi-arrow-left me-1'></i>
        </button>
        <button
          type='submit'
          className='btn btn-primary text-white'
          // onClick={() => {
          //   // setErrorMemo(data);
          //   setLifeErrorMemo(lifeData);
          //   if (  lifeData.every((item) => item === "")) return;
          //   interestRef?.current?.click();
          // }}
        >
          Next <i className='mdi mdi-arrow-right ms-1'></i>
        </button>
      </div>
      <SelectCover
        modal_id='cover-select'
        handleChange={handleCoverChange}
        covers={data}
      />
      <SelectLifeCover
        modal_id='lifecover-select'
        handleChange={handleLifeChange}
        covers={lifeData}
      />
    </form>
  );
};

export default Cover;
